import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'loren-expansion-panel',
    templateUrl: './loren-expansion-panel.component.html',
    styleUrls: ['./loren-expansion-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenExpansionPanelComponent {
    @Input() panelTitle: string;
    @Input() panelDescription: string;
    @Input() expandState;
    @Output() collapsed = new EventEmitter<void>();
    @Output() expanded = new EventEmitter<void>();

    collapse() {
        this.expandState = false;
    }
}
